import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntItems(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        code
        group {
          id
          name
        }
        subgroup {
          id
          name
        }
      }
      recordCount
    }
  }
`;

export function useGetContributorAsOptionsQuery() {
  return useLazyQuery(gqlGetValues);
  //return [null, { loading: null, data: null }];
}

export const FieldSelectCntItems = ({
  label = 'Κατηγορία Εισφορών',
  name = 'itemId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      recordLabel="group.name"
      recordLabel2="subgroup.name"
      recordLabel3="name"
      formatLabel={(r) =>
        `(${String(r.code).padStart(3, '0')}) - ${r.group.name} - ${r.subgroup.name} - ${r.name}`
      }
      // @ts-ignore
      //sbLabel={defaultValues?.batteriescollectionsState?.name ?? undefined}
      hook={useGetContributorAsOptionsQuery}
    />
  );
};

